import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, tap } from 'rxjs';
import { PaginatedRepository } from '../../services/pagination/paginated.repository';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { UltimateBeneficialOwnershipStructure } from '../../interfaces/ultimate-beneficial-ownership-structure/ultimate-beneficial-ownership-structure';
import { UltimateBeneficialOwnershipStructureForCreation } from '../../interfaces/ultimate-beneficial-ownership-structure/ultimate-beneficial-ownership-structure-for-creation';
import { UltimateBeneficialOwnershipStructureForUpdate } from '../../interfaces/ultimate-beneficial-ownership-structure/ultimate-beneficial-ownership-structure-for-update';


@Injectable({
  providedIn: 'root'
})
export class UltimateBeneficialOwnershipStructureService extends PaginatedRepository<UltimateBeneficialOwnershipStructure> {
  protected override _baseLink: string;

  constructor(
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig,
    http: HttpClient,
    messageService: ToastrService
  ) {
    super(http, messageService);

    this._baseLinkTemplate = `${this.config.rootUrl}/UltimateBeneficialOwnership/[0]/Structure`;
    this._baseLink = `${this.config.rootUrl}/UltimateBeneficialOwnership`;
  }

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
  }

  public getUltimateBeneficialOwnershipStructure = (ultimateBeneficialOwnershipRequestID: string, ultimateBeneficialOwnershipStructureID: string) => {
    this.populateBaseLink([ultimateBeneficialOwnershipRequestID]);

    return this.http.get<UltimateBeneficialOwnershipStructure>(`${this._baseLink}/${ultimateBeneficialOwnershipStructureID}`, this.generateHeaders());
  }

  public getUltimateBeneficialOwnershipStructures = (ultimateBeneficialOwnershipRequestID: string) => {
    this.populateBaseLink([ultimateBeneficialOwnershipRequestID]);

    return this.http.get<UltimateBeneficialOwnershipStructure[]>(this._baseLink, this.generateHeaders());
  }

  public createUltimateBeneficialOwnershipStructure(ultimateBeneficialOwnershipRequestID: string, newEvent: UltimateBeneficialOwnershipStructureForCreation): Observable<UltimateBeneficialOwnershipStructure> {
    this.populateBaseLink([ultimateBeneficialOwnershipRequestID]);

    return this.http.post<UltimateBeneficialOwnershipStructure>(this._baseLink, newEvent);
  }

  public updateUltimateBeneficialOwnershipStructure(ultimateBeneficialOwnershipRequestID: string, ultimateBeneficialOwnershipStructureID: string, ultimateBeneficialOwnershipStructure: UltimateBeneficialOwnershipStructureForUpdate): Observable<UltimateBeneficialOwnershipStructure> {
    this.populateBaseLink([ultimateBeneficialOwnershipRequestID]);

    return this.http.put<UltimateBeneficialOwnershipStructure>(`${this._baseLink}/${ultimateBeneficialOwnershipStructureID}`, ultimateBeneficialOwnershipStructure);
  }

  public deleteUltimateBeneficialOwnershipStructure = (ultimateBeneficialOwnershipRequestID: string, ultimateBeneficialOwnershipStructureID: string) => {
    this.populateBaseLink([ultimateBeneficialOwnershipRequestID]);
    
    return this.http.delete(`${this._baseLink}/${ultimateBeneficialOwnershipStructureID}`);
  }
}
